/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ResponseSleepCallCompletedEventStatus = {
  Woke: "woke",
  Interrupted: "interrupted",
  Cancelled: "cancelled",
} as const;
export type ResponseSleepCallCompletedEventStatus = ClosedEnum<
  typeof ResponseSleepCallCompletedEventStatus
>;

export type ResponseSleepCallCompletedEvent = {
  type: "response.sleep_call.completed";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  functionCallOutput?: string | undefined;
  status?: ResponseSleepCallCompletedEventStatus | undefined;
};

/** @internal */
export const ResponseSleepCallCompletedEventStatus$inboundSchema:
  z.ZodNativeEnum<typeof ResponseSleepCallCompletedEventStatus> = z.nativeEnum(
    ResponseSleepCallCompletedEventStatus,
  );
/** @internal */
export const ResponseSleepCallCompletedEventStatus$outboundSchema:
  z.ZodNativeEnum<typeof ResponseSleepCallCompletedEventStatus> =
    ResponseSleepCallCompletedEventStatus$inboundSchema;

/** @internal */
export const ResponseSleepCallCompletedEvent$inboundSchema: z.ZodType<
  ResponseSleepCallCompletedEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.sleep_call.completed"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  function_call_output: z.string().optional(),
  status: ResponseSleepCallCompletedEventStatus$inboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
    "function_call_output": "functionCallOutput",
  });
});
/** @internal */
export type ResponseSleepCallCompletedEvent$Outbound = {
  type: "response.sleep_call.completed";
  sequence_number: number;
  item_id: string;
  output_index: number;
  function_call_output?: string | undefined;
  status?: string | undefined;
};

/** @internal */
export const ResponseSleepCallCompletedEvent$outboundSchema: z.ZodType<
  ResponseSleepCallCompletedEvent$Outbound,
  z.ZodTypeDef,
  ResponseSleepCallCompletedEvent
> = z.object({
  type: z.literal("response.sleep_call.completed"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  functionCallOutput: z.string().optional(),
  status: ResponseSleepCallCompletedEventStatus$outboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
    functionCallOutput: "function_call_output",
  });
});

export function responseSleepCallCompletedEventToJSON(
  responseSleepCallCompletedEvent: ResponseSleepCallCompletedEvent,
): string {
  return JSON.stringify(
    ResponseSleepCallCompletedEvent$outboundSchema.parse(
      responseSleepCallCompletedEvent,
    ),
  );
}
export function responseSleepCallCompletedEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseSleepCallCompletedEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseSleepCallCompletedEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseSleepCallCompletedEvent' from JSON`,
  );
}
